import { Component, Injector, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { AppMenu } from './app-menu';

import { PermissionCheckerService } from '@abp/auth/permission-checker.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { AppUiCustomizationService } from '@shared/common/ui/app-ui-customization.service';
import { AppNavigationService } from './app-navigation.service';
import { HeaderComponent } from '@app/shared/layout/header.component';
import { EventsScheduleDto, EventsServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
    templateUrl: './top-bar-menu.component.html',
    selector: 'top-bar-menu',
    encapsulation: ViewEncapsulation.None
})
export class TopBarMenuComponent extends AppComponentBase implements OnInit {

    menu: AppMenu = null;
    userPendingUpdate = false;

    userLogged = this.appSession.user;
    schedule: EventsScheduleDto = undefined;

    constructor(
        injector: Injector,
        public permission: PermissionCheckerService,
        private _appSessionService: AppSessionService,
        private _uiCustomizationService: AppUiCustomizationService,
        private _appNavigationService: AppNavigationService,
        private _headerComponent: HeaderComponent,
        private _eventsService: EventsServiceProxy,
        
    ) {
        super(injector);
    }

    ngOnInit() {
        this.menu = this._appNavigationService.getMenu();
        this.userPendingUpdate = this._appSessionService.getUserPendingUpdate();
        this.getEventsSchedule();
    }

    showMenuItem(menuItem): boolean {
        if (menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' && this._appSessionService.tenant && !this._appSessionService.tenant.edition) {
            return false;
        }

        if (menuItem.requireduserUpdated && this.userPendingUpdate) {
            return false;
        }

        if (menuItem.permissionName) {
            return this.permission.isGranted(menuItem.permissionName);
        }

        if (menuItem.items && menuItem.items.length) {
            return this._appNavigationService.checkChildMenuItemPermission(menuItem);
        }

        return true;
    }

    changeProfile() : void {
        this._headerComponent.changeProfile();        
    }

    
  getEventsSchedule(): void {

    this._eventsService.getEventsScheduleForEdit()
      .subscribe(result => {

        if (result){
          this.schedule = result;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/nav/top-bar-menu.component.ts